import http from "./httpService";

export async function getBranchSelected() {
    
    return http.get("/jawis/BranchSelected");
}
export default {

    getBranchSelected
};